module.exports = __webpack_public_path__ + "img/P41920580KFeed.92f2d941.jpg";